import { P2TextDescription } from 'react-bootstrap-common-script';
import { SectionCard } from '../../../components/card';
import LegacyCompletionReminderSegment from './legacy-completion-reminder';
import LegacyDocumentsToBringSegment from './legacy-documents-to-bring';

/**
 * Legacy Stage E View - Same as commit a978266b (before Dec 16, 2025)
 * Simple layout without E1/E2/E3 views, stepper, or CPF withdrawal
 */
function StageELegacyView() {
  return (
    <div className="d-flex justify-content-center" style={{ marginTop: '3.875rem', marginBottom: 120 }}>
      <SectionCard
        required={false}
        stepperItems={[]}
        titleChildren={<P2TextDescription title={'Prepare for Completion'} />}
        contentChildren={
          <div className="polymer-stage-e">
            <LegacyCompletionReminderSegment />
            <LegacyDocumentsToBringSegment />
          </div>
        }
      />
    </div>
  );
}

export default StageELegacyView;
